module.exports = __webpack_public_path__ + "static/media/WEO76LIS0003.0a1673cd.svg";